import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  AppBar,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  LinearProgress,
  Menu,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";

import { format } from "../utils/mask.utils";
import isAuthenticated from "../utils/isAuthenticated";
import StatusUtils from "../utils/status.utils";
import PerfilUtils from "../utils/perfil.utils";

import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CancelIcon from "@mui/icons-material/Cancel";
import FolderDeleteIcon from "@mui/icons-material/FolderDelete";
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const getCookie = require("../utils/getCookie");

const PageContainer = styled.div`
  margin: 16px;
  padding: 32px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0px 0px 20px -18px #424242;
`;

const Inadimplente = (props) => {
  const { fkStatus } = props.match.params;

  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const [openLoadingProcessDialog, setOpenLoadingProcessDialog] = useState(false);
  
  const [registros, setRegistros] = useState([]);
  const [registrosGlobal, setRegistrosGlobal] = useState([]);
  const [message, setMessage] = useState("");
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [openGlobalSearchFullDialog, setOpenGlobalSearchFullDialog] = useState(false);

  const [keyword, setKeyword] = useState("");
  const [keywordGlobal, setKeywordGlobal] = useState('');
  const [pagina, setPagina] = useState(0);
  const [tamanhoDaLista, setTamanhoDaLista] = useState(5);
  const [numeroDePaginas, setNumeroDePaginas] = useState(1);
  const [totalDeRegistros, setTotalDeRegistros] = useState(0);
  const [unidades, setUnidades] = useState([]);
  const [fkUnidade, setFkUnidade] = useState("");
  const [alunos, setAlunos] = useState([]);
  const [titlePage, setTitlePage] = useState('');
  const [logged, setLogged] = useState(null);
  const [anchorElAccountMenu, setAnchorElAccountMenu] = useState(null);
  const [openAccountMenu, setOpenAccountMenu] = useState(false);
  const [status, setStatus] = useState('');
  const [openConfirmarEnvio, setOpenConfirmarEnvio] = useState(false);
  const [tipoProcessamento, setTipoProcessamento] = useState("");
  const [descricao, setDescricao] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const statusQueHabilitamOBotaoProcessar = ['d35bf861-5ddb-47ab-aa87-b561a8ea6434', '91e78324-fa5c-45ae-8000-6baafb6e9a76', 'ba56466b-0815-4890-9b45-c6c7a7f95204']
  const id = 0;
  const [maisDe60DiasDeAtraso, setMaisDe60DiasDeAtraso] = useState('');
  
  const [dataInicioFiltro, setDataInicioFiltro] = useState(null);
  const [dataFimFiltro, setDataFimFiltro] = useState(null);

  useEffect(() => {
    isAuthenticated().then((_) => {
      if (_.data) {
        setLogged(_.data.data);
      } else {
        setLogged(null);
      }
    });
  }, []);

  function carregarRegistros() {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente${
        keyword || maisDe60DiasDeAtraso || (dataInicioFiltro && dataFimFiltro) ? `/search/` : ""
      }?pagina=${
        pagina + 1
      }&tamanho=${tamanhoDaLista}&fkStatus=${fkStatus}&fkUnidade=${fkUnidade}${
        keyword ? `&keyword=${keyword}` : ""
      }${maisDe60DiasDeAtraso ? `&maisDe60DiasDeAtraso=${maisDe60DiasDeAtraso}` : ''}${dataInicioFiltro && dataFimFiltro ? `&dataInicioFiltro=${dataInicioFiltro}&dataFimFiltro=${dataFimFiltro}` : ``}`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            const { alunos } = data;
            if (alunos) {
              setAlunos(data.alunos);
            }

            setRegistros(data.data);

            setTotalDeRegistros(data.paginacao.totalDeRegistros);
            // setPagina(data.paginacao.pagina)
            // setTamanhoDaLista(data.paginacao.tamanhoDaLista)
            // setNumeroDePaginas(data.paginacao.numeroDePaginas)
          }
        })
        .catch((err) => setOpenLoadingDialog(true));
    });
  }

  function carregarRegistrosBuscaGlobal() {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/buscaglobal/?keyword=${keywordGlobal}`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setRegistrosGlobal(data.data);
          }
        })
        .catch((err) => setOpenLoadingDialog(true));
    });
  }

  useEffect(() => {
    carregarRegistrosBuscaGlobal();
  }, [keywordGlobal]);

  function exportarParaExcel() {
    const win = window.open(`${process.env.REACT_APP_DOMAIN_API}/api/relatorio/${fkStatus}/${getCookie("_token_spc_manager")}`, '_blank');
    setTimeout(() => {
      win?.close();
    }, 1000);
  }

  useEffect(() => {
    function carregarUnidades() {
      setOpenLoadingDialog(true);
      const token = getCookie("_token_spc_manager");
      const params = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/unidade/`, params).then(
        (response) => {
          const { status } = response;
          response
            .json()
            .then((data) => {
              setOpenLoadingDialog(false);
              if (status === 401) {
                setMessage(data.message);
                setOpenMessageDialog(true);
              } else if (status === 200) {
                setUnidades(
                  data.data.filter((item, index) => {
                    return item.codigoSig;
                  })
                );

                carregarRegistros();
              }
            })
            .catch((err) => setOpenLoadingDialog(true));
        }
      );
    }

    const statusMap = {
      "2c1ded57-2191-4232-9c23-b6c231fabeac": "Pendente de Remoção do SPC",
      "35498302-cdaf-424d-9b83-069faa33faff": "Adicionado ao SPC",
      "6ab41b40-c38e-4211-a4ee-68a2d3bda067": "Com inconsistências",
      "8e5b8e3e-a113-4630-92c7-c08ad302ed99": "Cancelado",
      "91e78324-fa5c-45ae-8000-6baafb6e9a76": "Confirmado pela Unidade",
      "ba56466b-0815-4890-9b45-c6c7a7f95204": "Aguardando Confirmação da Unidade",
      "d35bf861-5ddb-47ab-aa87-b561a8ea6434": "Não Processado",
      "d998e74f-a64e-43df-81e7-3b12e15b1855": "Removido do SPC"
    };

    function setPageTitle() {
      switch (fkStatus) {
        case 'd35bf861-5ddb-47ab-aa87-b561a8ea6434':
          setTitlePage('Não Processados')
          break;
        case 'ba56466b-0815-4890-9b45-c6c7a7f95204':
          setTitlePage('Aguardando aprovação da Unidade');
          break;
        case '91e78324-fa5c-45ae-8000-6baafb6e9a76':
          setTitlePage('Confirmados pela Unidade');
          break;
        case '6ab41b40-c38e-4211-a4ee-68a2d3bda067':
          setTitlePage('Registros com Inconsistências');
          break;
        case '35498302-cdaf-424d-9b83-069faa33faff':
          setTitlePage('Registros adicionados ao SPC');
          break;
        case '2c1ded57-2191-4232-9c23-b6c231fabeac':
          setTitlePage('Registros pendentes de remoção');
          break;
        case 'd998e74f-a64e-43df-81e7-3b12e15b1855':
          setTitlePage('Registros Removidos do SPC');
          break;
        case '8e5b8e3e-a113-4630-92c7-c08ad302ed99':
          setTitlePage('Registros Cancelados');
          break;
        default:
          // código a ser executado se nenhum dos casos anteriores for atendido
      }

      setStatus(statusMap[fkStatus]);
    }

    carregarUnidades();
    setPageTitle();
  }, [pagina, tamanhoDaLista, totalDeRegistros, keyword, fkUnidade, maisDe60DiasDeAtraso]);

  const handleChangePage = (event, newPage) => {
    setPagina(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setTamanhoDaLista(e.target.value);
    setPagina(0);
  };

  const onEncaminharParaUnidade = () => {
      setOpenLoadingProcessDialog(true);
      const token = getCookie("_token_spc_manager");
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          descricao,
          ids: selectedIds
        }),
      };
  
      fetch(
        `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/encaminharparaunidade`,
        params
      ).then((response) => {
        const { status } = response;
        response
          .json()
          .then((data) => {
            setOpenLoadingProcessDialog(false);
            if (status === 401) {
              setMessage(data.message);
              setOpenMessageDialog(true);
            } else if (status === 200) {
              setMessage(data.message);
              setOpenMessageDialog(true);
              setSelectedIds([]);
              carregarRegistros();
              // setRedirect(true);
            }
          })
          .catch((err) => setOpenLoadingProcessDialog(true));
      });
    };

  const confirmarProcessamento = (type) => {
    setOpenAccountMenu(false);
    setTipoProcessamento(type);

    if (type === "encaminharParaUnidade") {
      setDescricao(
        `Solicitamos a análise imediata dos dados cadastrais de inadimplência para adição a base SPC. Agradecemos pela colaboração.`
      );
    } else {
      setDescricao("");
    }

    if (type === "removerDoSPC") {
      // carregarMotivoExclusao();
    } else {
      setOpenConfirmarEnvio(true);
    }
  };

  const btConfirmarProcessamento = () => {
    setOpenConfirmarEnvio(false);

    if (tipoProcessamento === "encaminharParaUnidade") {
      onEncaminharParaUnidade();
    } else if (tipoProcessamento === "encaminharParaOSPC") {
      encaminharParaOSPC();
    } else if (tipoProcessamento === "confirmacaoUnidade") {
      onConfirmacaoUnidade();
    } else if (
      tipoProcessamento === "encaminharParaCorrecaoDeInconsistencias"
    ) {
      onConfirmacaoUnidadeCorrigirInconsistencias();
    }
  };

  const encaminharParaOSPC = () => {
    setOpenLoadingProcessDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        descricao,
        ids: selectedIds
      }),
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/encaminharparaospc`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingProcessDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setMessage(data.message);
            setOpenMessageDialog(true);
            carregarRegistros();
            setSelectedIds([]);
            // setRedirect(true);
          }
        })
        .catch((err) => setOpenLoadingProcessDialog(true));
    });
  };


  const onConfirmacaoUnidadeCorrigirInconsistencias = () => {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_spc_manager");
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        descricao,
        ids: selectedIds
      }),
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/encaminharparaunidadecorrigirinconsistencias`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          setOpenLoadingProcessDialog(false);
          if (status === 401) {
            setMessage(data.message);
            setOpenMessageDialog(true);
          } else if (status === 200) {
            setMessage(data.message);
            setOpenMessageDialog(true);
            carregarRegistros();
            setSelectedIds([]);
            // setRedirect(true);
          }
        })
        .catch((err) => setOpenLoadingProcessDialog(true));
    });
  };

  const onConfirmacaoUnidade = () => {
      setOpenLoadingDialog(true);
      const token = getCookie("_token_spc_manager");
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          descricao,
          ids: selectedIds
        }),
      };
  
      fetch(
        `${process.env.REACT_APP_DOMAIN_API}/api/inadimplente/confirmacaounidade`,
        params
      ).then((response) => {
        const { status } = response;
        response
          .json()
          .then((data) => {
            setOpenLoadingProcessDialog(false);
            if (status === 401) {
              setMessage(data.message);
              setOpenMessageDialog(true);
            } else if (status === 200) {
              setMessage(data.message);
              setOpenMessageDialog(true);
              carregarRegistros();
              setSelectedIds([]);
              // setRedirect(true);
            }
          })
          .catch((err) => setOpenLoadingDialog(true));
      });
    };

  const toggleSelectAll = () => {
    if (selectedIds.length === registros.length) {
      setSelectedIds([]);
    } else {
      const allIds = [...new Set(registros.map(row => row.id))];
      setSelectedIds(allIds);
    }
  };

  const toggleSelectOne = (id) => {
    const set = new Set(selectedIds);
    if (set.has(id)) {
      set.delete(id);
    } else {
      set.add(id);
    }
    setSelectedIds(Array.from(set));
  };

  const isAllSelected = registros.length > 0 && selectedIds.length === registros.length;

  const renderProcessarMenu = (
    <Menu
      anchorEl={anchorElAccountMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id="positioned-inadimplente-process-icon-button"
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={openAccountMenu}
      onClose={() => setOpenAccountMenu(false)}
    >
      {logged ? (
        logged.Perfil.nome === PerfilUtils.Administrador ||
        logged.Perfil.nome === PerfilUtils["Contas a Receber"] ? (
          <>
            {status === StatusUtils["Não Processado"] ? (
              <MenuItem
                onClick={() => confirmarProcessamento("encaminharParaUnidade")}
                disableRipple
              >
                <div
                  style={{
                    minWidth: 120,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <HourglassTopIcon fontSize="small" />
                  <div style={{ paddingLeft: 16 }}>Encaminhar para Unidade</div>
                </div>
              </MenuItem>
            ) : (
              ""
            )}

            {status === StatusUtils["Não Processado"] ||
            status === StatusUtils["Confirmado pela Unidade"] ? (
              <MenuItem
                onClick={() => confirmarProcessamento("encaminharParaOSPC")}
                disableRipple
              >
                <div
                  style={{
                    minWidth: 120,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <AccountBalanceIcon fontSize="small" />
                  <div style={{ paddingLeft: 16 }}>Encaminhar para o SPC</div>
                </div>
              </MenuItem>
            ) : (
              ""
            )}

            {status === StatusUtils["Confirmado pela Unidade"] ? (
              <MenuItem
                onClick={() =>
                  confirmarProcessamento(
                    "encaminharParaCorrecaoDeInconsistencias"
                  )
                }
                disableRipple
              >
                <div
                  style={{
                    minWidth: 120,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <AccountBalanceIcon fontSize="small" />
                  <div style={{ paddingLeft: 16 }}>
                    Corrigir Inconsistências
                  </div>
                </div>
              </MenuItem>
            ) : (
              ""
            )}

            {status === StatusUtils["Adicionado ao SPC"] ||
            status === StatusUtils["Pendente de Remoção do SPC"] ? (
              <MenuItem
                onClick={() => confirmarProcessamento("removerDoSPC")}
                disableRipple
              >
                <div
                  style={{
                    minWidth: 120,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <FolderDeleteIcon fontSize="small" />
                  <div style={{ paddingLeft: 16 }}>Remover do SPC</div>
                </div>
              </MenuItem>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {logged ? (
        status === StatusUtils["Aguardando Confirmação da Unidade"] &&
        logged.Perfil.nome === PerfilUtils.Funcionário ? (
          <MenuItem
            onClick={() => confirmarProcessamento("confirmacaoUnidade")}
            disableRipple
          >
            <div
              style={{ minWidth: 120, display: "flex", flexDirection: "row" }}
            >
              <CheckIcon fontSize="small" />
              <div style={{ paddingLeft: 16 }}>Confirmar</div>
            </div>
          </MenuItem>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {logged ? (
        status === StatusUtils["Aguardando Confirmação da Unidade"] &&
        logged.Perfil.nome === PerfilUtils.Funcionário ? (
          <MenuItem
            onClick={() => confirmarProcessamento("cancelar")}
            disableRipple
          >
            <div
              style={{ minWidth: 120, display: "flex", flexDirection: "row" }}
            >
              <CancelIcon fontSize="small" />
              <div style={{ paddingLeft: 16 }}>Cancelar</div>
            </div>
          </MenuItem>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {logged ? (
        status === StatusUtils["Com inconsistências"] &&
        logged.Perfil.nome === PerfilUtils.Funcionário ? (
          <MenuItem
            onClick={() => confirmarProcessamento("confirmacaoUnidade")}
            disableRipple
          >
            <div
              style={{ minWidth: 120, display: "flex", flexDirection: "row" }}
            >
              <CheckIcon fontSize="small" />
              <div style={{ paddingLeft: 16 }}>Confirmar</div>
            </div>
          </MenuItem>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {logged ? (
        status === StatusUtils["Com inconsistências"] &&
        logged.Perfil.nome === PerfilUtils.Funcionário ? (
          <MenuItem
            onClick={() => confirmarProcessamento("cancelar")}
            disableRipple
          >
            <div
              style={{ minWidth: 120, display: "flex", flexDirection: "row" }}
            >
              <CancelIcon fontSize="small" />
              <div style={{ paddingLeft: 16 }}>Cancelar</div>
            </div>
          </MenuItem>
        ) : (
          ""
        )
      ) : (
        ""
      )}
    </Menu>
  );

  return (
    <PageContainer>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 16,
        }}
      >
        <h3>{titlePage}</h3>
        <div style={{ flex: 1 }}></div>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <input
            type="text"
            style={{
              height: 32,
              border: "1px solid #e0e0e0",
              borderRadius: 3,
              outline: "none",
              paddingRight: 8,
              paddingLeft: 8,
              marginRight: 16
            }}
            placeholder="Pesquisar"
            onChange={(e) => setKeyword(e.target.value)}
          />

          <Tooltip title='Exportar para Excel'>
            <IconButton aria-label="delete" onClick={exportarParaExcel}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title='Busca geral'>
            <IconButton aria-label="busca global" onClick={() => setOpenGlobalSearchFullDialog(true)}>
              <PersonSearchIcon />
            </IconButton>
          </Tooltip>

          {logged && selectedIds.length > 0 ? (
            <div>
              {((status === StatusUtils["Não Processado"] ||
                status === StatusUtils["Confirmado pela Unidade"] ||
                status === StatusUtils["Adicionado ao SPC"]) &&
                logged.Perfil.nome === PerfilUtils.Administrador) ||
              logged.Perfil.nome === PerfilUtils["Contas a Receber"] ||
              ((status === StatusUtils["Aguardando Confirmação da Unidade"] ||
                status === StatusUtils["Com inconsistências"]) &&
                logged.Perfil.nome === PerfilUtils.Funcionário) ? (
                <Button
                  size="medium"
                  variant="outlined"
                  startIcon={<BuildCircleIcon />}
                  id="positioned-inadimplente-process-icon-button"
                  color="inherit"
                  disableElevation
                  onClick={(e) => {
                    setAnchorElAccountMenu(e.currentTarget);
                    setOpenAccountMenu(true);
                  }}
                  style={{marginLeft: 16}}
                >
                  Processar
                </Button>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {renderProcessarMenu}
          {/* <Button size="small" variant="contained" startIcon={<AddIcon />} style={{marginLeft: 8 }} onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN}/usuario/cadastro/`}>
            Novo
          </Button> */}
        </div>
      </div>
      {openLoadingDialog ? <LinearProgress /> : ''}
      {logged ? 
        <TableContainer>
          <Table sx={{ minWidth: 650, border: '1px solid #E0E0E0' }} aria-label="simple table">
            <TableHead style={{ backgroundColor: "#000000" }}>
              <TableRow>
                {statusQueHabilitamOBotaoProcessar.filter(id => id !== '91e78324-fa5c-45ae-8000-6baafb6e9a76').includes(fkStatus) && logged.Perfil.nome === PerfilUtils.Funcionário || 
                statusQueHabilitamOBotaoProcessar.filter(id => id !== 'ba56466b-0815-4890-9b45-c6c7a7f95204').includes(fkStatus) && (logged.Perfil.nome === PerfilUtils["Contas a Receber"] || logged.Perfil.nome === PerfilUtils.Administrador) ? <TableCell style={{ backgroundColor: '#FFFFFF', maxWidth: 64, width: 64}}>
                  <Checkbox style={{backgroundColor: '#FFFFFF'}} checked={isAllSelected} onChange={toggleSelectAll} />
                </TableCell> : ''}
                <TableCell>
                  <select
                    value={maisDe60DiasDeAtraso}
                    label="Tempo de Atraso"
                    // onChange={handleChange}
                    style={{
                      padding: 8,
                      height: 48,
                      border: "1px solid #e0e0e0",
                      outline: "none",
                      maxWidth: 32,
                      borderRadius: 3,
                    }}
                    onChange={(e) =>
                      setMaisDe60DiasDeAtraso(
                        e.target.options[e.target.selectedIndex].value
                      )
                    }>
                    <option value={'undefined'}>Tempo de Atraso</option>
                    <option value={'0'}>Pagamento em atraso entre 30 e 59 dias</option>
                    <option value={'1'}>Pagamento em atraso a mais de 60 dias</option>
                  </select>
                </TableCell>
                <TableCell style={{ color: "#fafafa" }}>Contrato</TableCell>
                <TableCell style={{ color: "#fafafa" }}>
                  <FormControl fullWidth>
                    {/* <InputLabel id="selecte-unidade-inadimplentes">Unidade</InputLabel> */}
                    <select
                      labelId="selecte-unidade-inadimplentes"
                      id="selecte-unidade-inadimplentes-component"
                      value={keyword}
                      label="Alunos"
                      // onChange={handleChange}
                      style={{
                        padding: 8,
                        height: 48,
                        border: "1px solid #e0e0e0",
                        outline: "none",
                        maxWidth: 150,
                        borderRadius: 3,
                      }}
                      onChange={(e) =>
                        setKeyword(e.target.options[e.target.selectedIndex].value)
                      }
                    >
                      <option value={""}>RESPONSÁVEL FINANCEIRO</option>
                      {alunos.map((item, index) => (
                        <option value={item.nome}>{item.nome}</option>
                      ))}
                    </select>
                  </FormControl>
                </TableCell>
                <TableCell style={{ color: "#fafafa" }}>
                  <FormControl fullWidth>
                    {/* <InputLabel id="selecte-unidade-inadimplentes">Unidade</InputLabel> */}
                    <select
                      labelId="selecte-unidade-inadimplentes"
                      id="selecte-unidade-inadimplentes-component"
                      value={fkUnidade}
                      label="Unidades"
                      // onChange={handleChange}
                      style={{
                        padding: 8,
                        height: 48,
                        border: "1px solid #e0e0e0",
                        outline: "none",
                        maxWidth: 150,
                        borderRadius: 3,
                      }}
                      onChange={(e) =>
                        setFkUnidade(
                          e.target.options[e.target.selectedIndex].value
                        )
                      }
                    >
                      <option value={""}>TODAS UNIDADES</option>
                      {unidades.map((item, index) => (
                        <option value={item.codigoSig}>{item.nome}</option>
                      ))}
                    </select>
                  </FormControl>
                </TableCell>
                {/* <TableCell style={{ color: "#fafafa" }}>Status</TableCell> */}
                <TableCell style={{ color: "#fafafa" }}>Valor</TableCell>
                <TableCell style={{ color: "#fafafa", display: 'flex', flexDirection: 'column' }}>
                  <table>
                    <tr>
                      <td>Início</td>
                      <td><input type="date" value={dataInicioFiltro ? dataInicioFiltro : null} onChange={(e) => setDataInicioFiltro(e.target.value)} /></td>
                    </tr>
                    <tr>
                      <td>Fim</td>
                      <td><input type="date" value={dataFimFiltro ? dataFimFiltro : null} onChange={(e) => setDataFimFiltro(e.target.value)} /></td>
                    </tr>
                    <tr>
                      <td><button onClick={carregarRegistros}>Aplicar</button></td>
                      <td><button onClick={() => {
                        setDataInicioFiltro(null);
                        setDataFimFiltro(null);
                        carregarRegistros();
                      }}>Limpar</button></td>
                    </tr>
                  </table>
                </TableCell>
                {/* <TableCell style={{color: '#fafafa'}}>Tempo de Atraso (Dias)</TableCell> */}
                <TableCell style={{ color: "#fafafa" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {registros.map((row) => (
                <TableRow key={row.id}>
                  {statusQueHabilitamOBotaoProcessar.filter(id => id !== '91e78324-fa5c-45ae-8000-6baafb6e9a76').includes(fkStatus) && logged.Perfil.nome === PerfilUtils.Funcionário || 
                  statusQueHabilitamOBotaoProcessar.filter(id => id !== 'ba56466b-0815-4890-9b45-c6c7a7f95204').includes(fkStatus) && (logged.Perfil.nome === PerfilUtils["Contas a Receber"] || logged.Perfil.nome === PerfilUtils.Administrador) ? <TableCell>
                    <Checkbox checked={selectedIds.includes(row.id)} onChange={() => toggleSelectOne(row.id)} />
                  </TableCell> : ''}
                  <TableCell>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                      {row.maisDe60DiasDeAtraso ? <Tooltip title={`Pagamento em atraso há mais de 60 dias`} arrow>
                    <div style={{width: 12, height: 12, minWidth: 12, maxWidth: 12, backgroundColor: '#EF5350', borderRadius: '50%', cursor: "pointer"}}></div>
                  </Tooltip> : 
                  <Tooltip title={`Pagamento em atraso entre 30 e 59 dias`} arrow>
                    <div style={{width: 12, height: 12, minWidth: 12, maxWidth: 12, backgroundColor: '#26A69A', borderRadius: '50%', cursor: "pointer"}}></div>
                  </Tooltip>}
                    </div>
                  </TableCell>
                  <TableCell>{row.contrato}</TableCell>
                  <TableCell>{row.nomeResponsavelFinanceiro}</TableCell>
                  <TableCell>{row.unidade}</TableCell>
                  {/* <TableCell>
                    {
                      <div
                        style={{
                          paddingRight: 8,
                          paddingLeft: 8,
                          borderRadius: 5,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#eeeeee",
                          border: "1px solid #e0e0e0",
                          color: "#212121",
                          marginLeft: 8,
                          fontSize: 11,
                          fontWeight: "bold",
                        }}
                      >
                        {row.Status.nome}
                      </div>
                    }
                  </TableCell> */}
                  <TableCell>{format(row.valorDaParcela)}</TableCell>
                  <TableCell>{row.vencimento}</TableCell>
                  {/* <TableCell>{row.tempoDeAtrasoDias}</TableCell> */}
                  <TableCell>
                    {
                      <Tooltip title="Editar">
                        <IconButton
                          onClick={() =>
                            (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${row.id}/edit/`)
                          }
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    }
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50, 100]}
                  colSpan={8}
                  count={totalDeRegistros}
                  rowsPerPage={tamanhoDaLista}
                  page={pagina}
                  labelRowsPerPage="Linhas por Página"
                  SelectProps={{
                    inputProps: {
                      "aria-label": "Linhas por Página",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer> : ''
      }
      {/* <Dialog open={openLoadingDialog}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: 120,
            height: 120,
          }}
        >
          <CircularProgress />
        </div>
      </Dialog> */}
      <Dialog
        open={openMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Atenção</DialogTitle>
        <DialogContent style={{ width: 400 }}>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenMessageDialog(false)}>OK</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirmarEnvio}>
        <DialogTitle>
          {tipoProcessamento === "encaminharParaUnidade"
            ? "Encaminhando para Unidade"
            : ""}
          {tipoProcessamento === "encaminharParaOSPC"
            ? "Encaminhando para o SPC"
            : ""}
          {tipoProcessamento === "removerDoSPC" ? "Removendo do SPC" : ""}
          {tipoProcessamento === "cancelar" ? "Cancelamento" : ""}
          {tipoProcessamento === "confirmacaoUnidade" ? "Confirmação" : ""}
          {tipoProcessamento === "encaminharParaCorrecaoDeInconsistencias"
            ? "Correção de Inconsistências"
            : ""}
        </DialogTitle>
        <DialogContent style={{ width: 500 }}>
          <DialogContentText>
            {/* {tipoProcessamento === 'encaminharParaUnidade' ? 'Você está prestes a encaminhar este registro, para análise da unidade.' : ''}
            {tipoProcessamento === 'encaminharParaOSPC' ? 'Encaminhando para o SPC' : ''}
            {tipoProcessamento === 'removerDoSPC' ? 'Removendo do SPC' : ''}
            {tipoProcessamento === 'cancelar' ? 'Cancelamento' : ''} */}
            {tipoProcessamento === "encaminharParaCorrecaoDeInconsistencias"
              ? `Você confirma o encaminhamento de ${selectedIds.length} registro(s) para que a unidade educacional responsável prossiga com a análise?`
              : ""}
            {tipoProcessamento === "encaminharParaUnidade"
              ? `Você confirma o encaminhamento de ${selectedIds.length} registro(s) para que a unidade educacional responsável prossiga com a análise?`
              : ""}
            {tipoProcessamento === "encaminharParaOSPC" ||
            tipoProcessamento === "confirmacaoUnidade"
              ? `Você confirma que ${selectedIds.length} registro(s) atendem aos critérios de inadimplência e devem ser encaminhados ao Serviço de Proteção de Crédito (SPC)?`//"Você confirma que o registro atende aos critérios de inadimplência e que deve ser enviado ao Serviço de Proteção de Crédito (SPC)?"
              : ""}
            {tipoProcessamento === "cancelar"
              ? "O processo de cancelamento estabelece ao indivíduo um prazo de 30 dias para a execução das negociações, caso o seguinte registro continue inadimplente, automáticamente será reclassificado como não processado, iniciando um novo ciclo de avaliação."
              : ""}
          </DialogContentText>
          <div style={{ marginBottom: 8, marginTop: 8 }}>

          </div>
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            multiline
            label="Justificativa"
            rows={2}
            variant="standard"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmarEnvio(false)}>Cancelar</Button>
          <Button onClick={btConfirmarProcessamento}>Enviar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openLoadingProcessDialog}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: 120,
            height: 120,
          }}
        >
          <CircularProgress />
        </div>
      </Dialog>

      <Dialog
        fullScreen
        open={openGlobalSearchFullDialog}
        onClose={() => setOpenGlobalSearchFullDialog(false)}
        // TransitionComponent={Transition}
        >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{backgroundColor: '#000000', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setOpenGlobalSearchFullDialog(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <div style={{flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
              <input type="text" style={{
                height: 48,
                width: '50%',
                backgroundColor: '#424242',
                borderRadius: 5,
                outline: 'none',
                border: 'none',
                paddingLeft: 16,
                paddingRight: 16,
                color: '#FFFFFF',
              }} 
              placeholder='Busca Global' 
              onChange={e => setKeywordGlobal(e.target.value)}/>
            </div>
          </Toolbar>
        </AppBar>
        {openLoadingDialog ? <LinearProgress /> : ''}
      <TableContainer>
        <Table sx={{ minWidth: 650, border: '1px solid #E0E0E0' }} aria-label="simple table">
          <TableHead style={{ backgroundColor: "#000000" }}>
            <TableRow>
              <TableCell></TableCell>
              <TableCell style={{ color: "#fafafa" }}>Contrato</TableCell>
              <TableCell style={{ color: "#fafafa" }}>
                RESPONSÁVEL FINANCEIRO
              </TableCell>
              <TableCell style={{ color: "#fafafa" }}>
                UNIDADE
              </TableCell>
              <TableCell style={{ color: "#fafafa" }}>Status</TableCell>
              <TableCell style={{ color: "#fafafa" }}>Valor</TableCell>
              <TableCell style={{ color: "#fafafa" }}>Vencimento</TableCell>
              {/* <TableCell style={{color: '#fafafa'}}>Tempo de Atraso (Dias)</TableCell> */}
              <TableCell style={{ color: "#fafafa" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {registrosGlobal.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                    {row.maisDe60DiasDeAtraso ? <Tooltip title={`Pagamento em atraso há mais de 60 dias`} arrow>
                  <div style={{width: 12, height: 12, minWidth: 12, maxWidth: 12, backgroundColor: '#EF5350', borderRadius: '50%', cursor: "pointer"}}></div>
                </Tooltip> : 
                <Tooltip title={`Pagamento em atraso entre 30 e 59 dias`} arrow>
                  <div style={{width: 12, height: 12, minWidth: 12, maxWidth: 12, backgroundColor: '#26A69A', borderRadius: '50%', cursor: "pointer"}}></div>
                </Tooltip>}
                  </div>
                </TableCell>
                <TableCell>{row.contrato}</TableCell>
                <TableCell>{row.nomeResponsavelFinanceiro}</TableCell>
                <TableCell>{row.unidade}</TableCell>
                <TableCell>
                  {
                    <div
                      style={{
                        paddingRight: 8,
                        paddingLeft: 8,
                        borderRadius: 5,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#eeeeee",
                        border: "1px solid #e0e0e0",
                        color: "#212121",
                        marginLeft: 8,
                        fontSize: 11,
                        fontWeight: "bold",
                      }}
                    >
                      {row.Status.nome}
                    </div>
                  }
                </TableCell>
                <TableCell>{format(row.valorDaParcela)}</TableCell>
                <TableCell>{row.vencimento}</TableCell>
                {/* <TableCell>{row.tempoDeAtrasoDias}</TableCell> */}
                <TableCell>
                  {
                    <Tooltip title="Abrir">
                      <IconButton
                        onClick={() =>
                          (window.location.href = `${process.env.REACT_APP_DOMAIN}/inadimplente/${row.id}/edit/`)
                        }
                      >
                        <OpenInNewIcon />
                      </IconButton>
                    </Tooltip>
                  }
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </Dialog>
    </PageContainer>
  );
};

export default Inadimplente;
